
/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

const state = {
    type: null,
    message: null
};

const getters = {
    getType: state => state.type,
    getMessage: state => state.message
};

const actions = {
    success({ commit }, message) {
        commit('success', message);
    },
    error({ commit }, message) {
        commit('error', message);
    },
    clear({ commit }) {
        commit('clear');
    }
};

const mutations = {
    success(state, message) {
        state.type = 'alert-success';
        state.message = message;
    },
    error(state, message) {
        state.type = 'alert-danger';
        state.message = message;
    },
    clear(state) {
        state.type = null;
        state.message = null;
    }
};

export const alert = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
